<section id="replays-search">

  <ion-modal class="datetime-modal" trigger="open-dateBy">
    <ng-template>
      <ion-content>
        <ion-datetime
          id="dateBy"
          [presentation]="'date'"
          [showDefaultButtons]="true"
          (ionChange)="setDate($event)"
          [value]="formVal['dateBy'].value | dateFormat: 'YYYY-MM-DDTHH:mm'"
          class="!tw-h-full"
        ></ion-datetime>
      </ion-content>
    </ng-template>
  </ion-modal>

  <div class="tw-pb-[14px]">
    <div class="tw-flex tw-flex-col">
      <span class="label tw-text-[16px] tw-w-full">By date</span>

      <ion-input
        mode="md"
        class="tw-w-full tw-h-[38px] !tw-min-h-[38px] !tw-mb-[16px]"
        [value]="formVal['dateBy'].value"
        type="text"
        placeholder="MM/DD/YYYY"
        maxlength="10"
        [maskito]="dateOfBirthMask"
        [maskitoElement]="maskPredicate"
        (click)="inputDate($event)"
        (keyup)="inputDate($event)"
        (backspace)="inputDate($event)"
      ></ion-input>
      <img
        src="/assets/images/account_settings/calendar.png"
        class="dateBy"
        id="open-dateBy"
      >
    </div>

    <div class="tw-flex tw-flex-col">
      <span class="label tw-text-[16px] tw-w-full">Breed</span>

      <ion-select
        [value]="formVal['breed'].value"
        label-placement="stacked"
        interface="popover"
        toggleIcon="chevron-down-outline"
        expandedIcon="chevron-up-outline"
        class="tw-h-[38px] !tw-min-h-[38px] !tw-mb-[16px] !tw-rounded-[4px]"
        (ionChange)="selectBreed($event)"
      >
        <ion-select-option
          [value]="item.key"
          *ngFor="let item of HORSE_BREED|keyvalue; trackBy: trackByFn"
        >
          <span>{{ item.value }}</span>
        </ion-select-option>
      </ion-select>
    </div>

    <div class="tw-flex tw-justify-center tw-py-2">
      <span class="label">
        Or
      </span>
    </div>

    <div class="tw-flex tw-flex-col">
      <span class="label tw-text-[16px] tw-w-full">By Runner Name</span>
      <ion-input
        mode="md"
        #inputRunnerName
        class="tw-w-full tw-h-[38px] !tw-min-h-[38px] !tw-mb-[16px]"
        type="text"
        [value]="formVal['runnerName'].value"
        (click)="searchName('runner', $event, 'click')"
        (keyup)="searchName('runner', $event, 'keyup')"
        (backspace)="searchName('runner', $event, 'backspace')"
      >
        <ion-spinner *ngIf="isLoadingRunner" name="dots" slot="end"></ion-spinner>
        <ion-icon
          *ngIf="formVal['runnerName'].value?.length > 2"
          slot="end"
          name="close"
          aria-hidden="true"
          (click)="formVal['runnerName']?.setValue(''); search();"
          class="tw-mr-[4px]"
        ></ion-icon>
      </ion-input>

      <div
        *ngIf="type==='runner'"
        class="selector-custom selector-custom-runner-name tw-shadow-2xl"
      >
        <ion-list
          #popoverListRunner
          [ngClass]="{
            'tw-overflow-auto': true,
            '!tw-p-0': runnersName?.length === 0
          }"
        >
          <ion-item
            *ngFor="let runner of runnersName"
            [button]="true"
            [detail]="false"
            (click)="selectName(runner, 'runner')"
          >
            {{ runner }}
          </ion-item>
        </ion-list>
      </div>
    </div>

    <div class="tw-flex tw-flex-col">
      <span class="label tw-text-[16px] tw-w-full">Head to Head</span>
      <ion-input
        mode="md"
        class="tw-w-full tw-h-[38px] !tw-min-h-[38px] !tw-mb-[16px]"
        type="text"
        [value]="formVal['headToHead'].value"
        (click)="searchName('head', $event, 'click')"
        (keyup)="searchName('head', $event, 'keyup')"
        (backspace)="searchName('head', $event, 'backspace')"
      >
        <ion-spinner *ngIf="isLoadingHead" name="dots" slot="end"></ion-spinner>
        <ion-icon
          *ngIf="formVal['headToHead'].value?.length > 2"
          slot="end"
          name="close"
          aria-hidden="true"
          (click)="formVal['headToHead']?.setValue(''); search();"
          class="tw-mr-[4px]"
        ></ion-icon>
      </ion-input>

      <div
        *ngIf="type==='head'"
        class="selector-custom selector-custom-runner-name tw-shadow-2xl"
      >
        <ion-list
          #popoverListHead
          [ngClass]="{
            'tw-overflow-auto': true,
            '!tw-p-0': headToHeadName?.length === 0
          }"
        >
          <ion-item
            *ngFor="let runner of headToHeadName"
            [button]="true"
            [detail]="false"
            (click)="selectName(runner, 'head')"
          >
            {{ runner }}
          </ion-item>
        </ion-list>
      </div>
    </div>
  </div>



  <div class="table-totals">
    <div class="tw-px-[6px] tw-pb-[16px] tw-flex tw-justify-between tw-items-end">
      <span>{{ replays?.length + ' Results Found' }}</span>
      <ion-button
        class="btn-clear"
        *ngIf="replays?.length !== 0"
        (click)="clear()"
      >Clear</ion-button>
    </div>

    <div class="tw-overflow-auto">
      <table *ngIf="replays?.length !== 0">
        <thead>
          <tr>
            <th><span class="tw-w-[118px]">Track</span></th>
            <th><span>Date</span></th>
            <th><span>Breed</span></th>
            <th><span>Race</span></th>
            <th><span class="tw-w-[80px]">Distance</span></th>
            <th><span>Surface</span></th>
            <th><span>Purse</span></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let replay of replays; index as i" (click)="getReplayVideo(replay)">
            <td>
              <span>{{ replay?.track }}</span>
            </td>
            <td class="tw-table-cell tw-items-center">
              <span class="tw-w-[85px]">{{ replay?.date | dateFormat: 'MM-DD-YYYY' }}</span>
            </td>
            <td>
              <span>{{ replay?.breed }}</span>
            </td>
            <td>
              <span>{{ replay?.race }}</span>
            </td>
            <td>
              <span>{{ replay?.distance }}</span>
            </td>
            <td>
              <span>{{ replay?.surface }}</span>
            </td>
            <td>
              <span>{{ '$' + (replay?.purse | numberWithCommas: 0) }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

</section>
